import type {
  Account,
  RestoreAccountConnectivityConfig,
} from '@repo/api-gw-sdk';

import type { Step } from '@/components/wizard/Step';

import { AwsRestoreAccountConfigVpcSelection } from './awsRestoreAccountConfigVpcSelection';
import { GcpRestoreAccountConfigVpcSelection } from './gcpRestoreAccountConfigVpcSelection';

export interface RestoreAccountConfigState {
  account: Account;
  config: RestoreAccountConnectivityConfig;
}

export const AwsRestoreAccountConfigFlow: Step<RestoreAccountConfigState> = {
  id: 'vpc_selection',
  Component: AwsRestoreAccountConfigVpcSelection,
  next: [],
};

export const GcpRestoreAccountConfigFlow: Step<RestoreAccountConfigState> = {
  id: 'network_selection',
  Component: GcpRestoreAccountConfigVpcSelection,
  next: [],
};
